import { Component, OnInit } from '@angular/core';
import { Contract, Data } from '@mlc/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of, switchMap } from 'rxjs';
import { UserProductWalletPerfDetail } from 'src/app/core/models/user-product-wallet-perf-detail.model';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';
import { COLOR_PERFORMANCE } from '../../core/constants/colorPerformance';
import { ICON_TEXT_COLOR } from '../../core/constants/iconTextColor';

@UntilDestroy()
@Component({
    selector: 'app-wallet-performance-table',
    templateUrl: './wallet-performance-table.component.html',
    styleUrls: ['./wallet-performance-table.component.scss'],
    standalone: false
})
export class WalletPerformanceTableComponent implements OnInit {

  public iconTextColor: string = ICON_TEXT_COLOR;
  public colorPerformance: string = COLOR_PERFORMANCE;
  public busy: boolean = true;
  public performanceTable!: Data<UserProductWalletPerfDetail>[] | undefined;

  constructor(private contractService: ContractService){}

  ngOnInit(): void {
    this.contractService.get()
    .pipe(
      untilDestroyed(this),
      switchMap((contract: Data<Contract> | undefined) => {
        this.busy = true;
        this.performanceTable = undefined;
        if (!contract?.attributes.latestUserProductWalletPerf.data) {
          this.busy = false;
          return of();
        }
        return this.contractService.getPerformanceTable(contract.id)
      })
    )
    .subscribe({
      next: (performanceTable: Data<UserProductWalletPerfDetail>[]) => {
        this.performanceTable = performanceTable;
        this.busy = false;
      }
    });
  }
}
